// Import utilities
import { onReady } from '@automator/utilities';

// Import style
import './style.scss';

// Import images
import './img/logo-horizontal.svg';
import './img/robot-feedback.svg';
import './img/robot-site-not-connected.svg';
import './img/credits-left-hundred.svg';
import './img/credits-left-zero.svg';

// Import notification system.
import Notifications from './notification-system';
import ReviewBanner from './review-banner';
import MenuHighlighter from './menu-highlighter';

// Invoke classes when the DOM is ready
onReady( () => {
	new Notifications();
	new ReviewBanner();
	new MenuHighlighter();
} );
